import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/jobs',
    name: 'jobs',
    meta: {
      title: 'Jobs'
    },
    component: () => import('@/views/jobs/JobListView.vue')
  },
  {
    path: '/job-requests',
    name: 'job-requests',
    meta: {
      title: 'Job Requests'
    },
    component: () => import('@/views/jobs/JobRequestsListView.vue')
  },
  {
    path: '/job-requests-rejection-reasons',
    name: 'job-requests-rejection-reasons',
    meta: {
      title: 'Rejection Reasons of Job Requests'
    },
    component: () => import('@/views/jobs/JobRequestsRejectReasonsListView.vue')
  }
]

export default routes
